import React from 'react'
import './LoadSpenner.css'
export default function LoaderSpinner() {
    return (
        <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}
